import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { frFR } from '@mui/material/locale';
import ReactGA from 'react-ga4';

import './index.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'react-tooltip/dist/react-tooltip.css';
import 'primeicons/primeicons.css';

import { default as Routes } from "./Routes";
import reportWebVitals from './reportWebVitals';

// Coquille applicative : chargée en dernier pour primer sur les autres feuilles.
import './assets/css/shell.css';

// Composants Material UI (menu du compte, agenda) alignés sur la charte Lokapp.
const theme = createTheme({
    palette: {
        primary: { main: "#00043c" },
        secondary: { main: "#005d6c" }
    },
    typography: {
        fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
    },
    shape: {
        borderRadius: 8
    }
}, frFR);

// Google Analytics uniquement hors environnement local.
if (window.location.href.indexOf("localhost") === -1) {
    ReactGA.initialize('G-CTK55443Y5');
}

const router = createBrowserRouter(Routes());

// L'en-tete du site est colle en z-index 1300 : sans ce reglage, les fenetres modales
// (PrimeReact les place a 1100) passent dessous et leur titre est recouvert.
const primeReactConfig = {
    zIndex: {
        modal: 1400,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100
    }
};

// v7_startTransition : les navigations côté client sont rendues en transition,
// une page qui « suspend » (Await, lazy) n'interrompt plus le rendu (erreur #426).
ReactDOM.createRoot(document.getElementById("root")).render(
    <PrimeReactProvider value={primeReactConfig}>
        <ThemeProvider theme={theme}>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </ThemeProvider>
    </PrimeReactProvider>
);

reportWebVitals();
